var _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgSearch(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 16,
    viewBox: "0 0 17 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.0069 13.8453L13.0507 11.0607C14.0045 9.91268 14.522 8.49506 14.5201 7.03566C14.5201 5.73596 14.1121 4.46544 13.3478 3.38477C12.5835 2.30411 11.4971 1.46183 10.2261 0.964456C8.95511 0.467081 7.55653 0.336945 6.20722 0.590504C4.85792 0.844064 3.61851 1.46993 2.64572 2.38896C1.67293 3.30799 1.01045 4.47891 0.742056 5.75364C0.473663 7.02837 0.611412 8.34967 1.13788 9.55044C1.66435 10.7512 2.5559 11.7775 3.69978 12.4996C4.84367 13.2217 6.18851 13.6071 7.56424 13.6071C9.10901 13.6089 10.6096 13.12 11.8247 12.2189L14.7722 15.0117C14.8531 15.0887 14.9492 15.1498 15.0552 15.1915C15.1611 15.2332 15.2748 15.2547 15.3896 15.2547C15.5043 15.2547 15.618 15.2332 15.7239 15.1915C15.8299 15.1498 15.9261 15.0887 16.0069 15.0117C16.0884 14.9354 16.1531 14.8445 16.1972 14.7444C16.2414 14.6443 16.2641 14.537 16.2641 14.4285C16.2641 14.3201 16.2414 14.2127 16.1972 14.1126C16.1531 14.0125 16.0884 13.9217 16.0069 13.8453ZM2.34736 7.03566C2.34736 6.06088 2.65333 5.108 3.22656 4.2975C3.7998 3.487 4.61457 2.85529 5.56783 2.48226C6.52109 2.10923 7.57003 2.01162 8.582 2.20179C9.59398 2.39196 10.5235 2.86136 11.2531 3.55064C11.9827 4.23991 12.4796 5.1181 12.6809 6.07415C12.8822 7.0302 12.7789 8.02117 12.384 8.92175C11.9892 9.82232 11.3205 10.5921 10.4626 11.1336C9.60467 11.6752 8.59604 11.9642 7.56424 11.9642C6.18064 11.9642 4.8537 11.445 3.87535 10.5207C2.897 9.5964 2.34736 8.3428 2.34736 7.03566Z",
    fill: "url(#paint0_linear_518_2487)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_518_2487",
    x1: 8.43624,
    y1: 0.464233,
    x2: 8.43624,
    y2: 15.2547,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#333333"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#111111"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.e3e69785f7ad5a2d307ba2ec2b54cf78.svg";
export { ForwardRef as ReactComponent };